export const styles = {
  wrapper: {
    display: 'flex',
    backgroundColor: '#fff',
    paddingTop: 20,
  },
  itemWrapper: {
    padding: '0 20px',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    color: '#8A96A0',
    fontSize: 13,
    fontWeight: 'bold',
  },
  value: {
    fontSize: 16,
    color: '#4E4E4E',
  },
  diff: {
    fontSize: 8,
    color: '#EE4360',
    '&.green': {
      color: '#388849',
    },
  },
  select: {
    alignSelf: 'center',
    margin: '0 0 0 auto',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/CampaignPerforming/Charts/ChartHeader/styles.js